import Mock from 'mockjs';
import homeApi from './mockData/home'

// 定义Mock请求拦截
Mock.mock('/api/home/getData', homeApi.getMockDataList);